import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getStatuses,
    getSources
} from "./ViewershipClient";
import {changeViewership} from "./viewershipSlice";
import {changeViewershipSearch} from "./viewershipSearchSlice";
import {getPlatformNames, getServices, getTerritories, getUsageMarkets} from "../Platform/PlatformClient";
import {getLicensees} from "../License/LicenseClient";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function ViewershipSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const { register, handleSubmit, control, setValue, reset } = useForm();
    // const {register, handleSubmit} = useForm();
    const [platformNameDropdown, setPlatformNameDropdown] = useState([]);
    const [selectedPlatformName, setSelectedPlatformName] = useState('');
    const [platformServiceDropdown, setPlatformServiceDropdown] = useState([]);
    const [selectedPlatformService, setSelectedPlatformService] = useState('');
    const [usageMarketDropdown, setUsageMarketDropdown] = useState([]);
    const [selectedUsageMarket, setSelectedUsageMarket] = useState('');
    const [territoryDropdown, setTerritoryDropdown] = useState([]);
    const [selectedTerritory, setSelectedTerritory] = useState('');
    const [sourceDropdown, setSourceDropdown] = useState([]);
    const [selectedSource, setSelectedSource] = useState('');
    const [statusDropdown, setStatusDropdown] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [licenseeDropdown, setLicenseeDropdown] = useState([]);
    const [selectedLicensee, setSelectedLicensee] = useState('');
    const setupsDropdown = ["","Has","None"];
    const [selectedParticipations, setSelectedParticipations] = useState('');
    const [selectedResiduals, setSelectedResiduals] = useState('');
    const [selectedRoyalties, setSelectedRoyalties] = useState('');
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [viewershipValue, setViewershipValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [viewerships, setViewerships] = useState([]);

    const handleClearClick = () => {
        setViewershipValue("");
    };

    const handleClearViewershipClick = () => {
        setViewershipValue("");
    };

    const fetchPlatformNames = () =>
        getPlatformNames()

            .then(data => {
                console.log("Platform Names");
                console.log(data);
                console.log("Platform Names with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPlatformNameDropdown(data);
            })

    const fetchPlatformServices = () => {
        getServices()

            .then(data => {
                console.log("Platform Services");
                console.log(data);
                console.log("Platform Services with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPlatformServiceDropdown(data);
            })}


    const fetchUsageMarkets = () =>
        getUsageMarkets()

            .then(data => {
                console.log("UsageMarkets");
                console.log(data);
                console.log("Viewership Markets with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setUsageMarketDropdown(data);
            })

    const fetchTerritories = () =>
        getTerritories()

            .then(data => {
                console.log("Territories");
                console.log(data);
                console.log("Territories with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setTerritoryDropdown(data);
            })


    const fetchSources = () =>
        getSources()

            .then(data => {
                console.log("Sources");
                console.log(data);
                console.log("Sources with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setSourceDropdown(data);
            })

    const fetchStatuses = () =>
        getStatuses()

            .then(data => {
                console.log("Statuses");
                console.log(data);
                console.log("Statuses with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setStatusDropdown(data);
            })


    const fetchLicensees = () =>
        getLicensees()

            .then(data => {
                console.log("Licensees");
                console.log(data);
                console.log("Licensees with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setLicenseeDropdown(data);
            })


    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchPlatformNames();
        fetchPlatformServices();
        fetchUsageMarkets();
        fetchTerritories();
        fetchSources();
        fetchStatuses();
        fetchLicensees();
    }, []);


    function onSubmit(data) {
        console.log("here's my viewership search data before I submit it ")
        console.log({data});
        dispatchData(changeViewershipSearch({
            productId: data.productId,
            productName: data.productName,
            episodeName: data.episodeName,
            photoStartDateFrom: data.photoStartDateFrom,
            photoStartDateTo: data.photoStartDateTo,
            seriesExternalId: data.seriesExternalId,
            seriesName: data.seriesName,
            seasonExternalId: data.seasonExternalId,
            seasonNumberFrom: data.seasonNumberFrom,
            seasonNumberTo: data.seasonNumberTo,
            seasonName: data.seasonName,
            platformId: data.platformId,
            platformNames: data.platformNames,
            service: data.service,
            usageMarket: data.usageMarket,
            territory: data.territory,
            viewDateFrom: data.viewDateFrom,
            viewDateTo: data.viewDateTo,
            viewsFrom: data.viewsFrom,
            viewsTo: data.viewsTo,
            viewedMinutesFrom: data.viewedMinutesFrom,
            viewedMinutesTo: data.viewedMinutesTo,
            ratingFrom: data.ratingFrom,
            ratingTo: data.ratingTo,
            id: data.id,
            externalId: data.externalId,
            source: data.source,
            status: data.status,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeViewership({
            viewershipGridRefresh: true
        }));
    };


    const handleClear = () => {

        reset({
            productId: '',
            productName:  '',
            episodeName:  '',
            photoStartDateFrom:  '',
            photoStartDateTo:  '',
            seriesExternalId:  '',
            seriesName:  '',
            seasonExternalId:  '',
            seasonNumberFrom:  '',
            seasonNumberTo:  '',
            seasonName:  '',
            platformId:  '',
            platformNames:  '',
            service:  '',
            usageMarket:  '',
            territory:  '',
            viewDateFrom:  '',
            viewDateTo:  '',
            viewsFrom:  '',
            viewsTo:  '',
            viewedMinutesFrom:  '',
            viewedMinutesTo:  '',
            ratingFrom:  '',
            ratingTo:  '',
            id: '',
            externalId:  '',
            source:  '',
            status:  '',
            participations:  '',
            residuals:  '',
            royalties:  ''
        });

        setSelectedPlatformName('');
        setSelectedPlatformService('');
        setSelectedUsageMarket('');
        setSelectedTerritory('');
        setSelectedSource('');
        setSelectedStatus('');
        setSelectedLicensee('');
        setSelectedParticipations('');
        setSelectedResiduals('');
        setSelectedRoyalties('');

        gridClear()

    };


    const handlePlatformNameChange = (platformNameEvent) => {
        setSelectedPlatformName(platformNameEvent.target.value);
        console.log("This is for the selected Value");
        console.log(platformNameEvent.target.value);
    };

    const handlePlatformServiceChange = (platformServiceEvent) => {
        setSelectedPlatformService(platformServiceEvent.target.value);
        console.log("This is for the selected Value");
        console.log(platformServiceEvent.target.value);
    };

    const handleUsageMarketChange = (usageMarketEvent) => {
        setSelectedUsageMarket(usageMarketEvent.target.value);
        console.log("This is for the selected Value");
        console.log(usageMarketEvent.target.value);
    };
    const handleTerritoryChange = (territoryEvent) => {
        setSelectedTerritory(territoryEvent.target.value);
        console.log("This is for the selected Value");
        console.log(territoryEvent.target.value);
    };

    const handleSourceChange = (sourceEvent) => {
        setSelectedSource(sourceEvent.target.value);
        console.log("This is for the selected Value");
        console.log(sourceEvent.target.value);
    };

    const handleStatusChange = (statusEvent) => {
        setSelectedStatus(statusEvent.target.value);
        console.log("This is for the selected Value");
        console.log(statusEvent.target.value);
    };
    const handleLicenseeChange = (licenseeEvent) => {
        setSelectedLicensee(licenseeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(licenseeEvent.target.value);
    };

    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };
    const handleClearPlatformName = () => {
        setSelectedPlatformName("");}


    const selectR2mRef = useRef();

    const onClear = () => {
        // selectR2mRef.current.select.clearValue();
        // selectR2mRef.Clear;
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 420, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('productId', { required: false })}
                               id="productId"   name="productId"  label="Product ID" aria-describedby="productId_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('productName', { required: false })}
                               id="productName"   name="productName"  label="Product Name" aria-describedby="productName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('episodeName', { required: false })}
                               id="episodeName"   name="episodeName"  label="Episode Name" aria-describedby="episodeName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <FormDatePicker
                        name="photoStartDateFrom"
                        label="Photo From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="photoStartDateTo"
                        label="Photo To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateFrom', { required: false })}*/}
                    {/*           id="photoStartDateFrom"   name="photoStartDateFrom"  label="Photo From" aria-describedby="photoStartDateFrom_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateTo', { required: false })}*/}
                    {/*           id="photoStartDateTo"   name="photoStartDateTo"  label="Photo To" aria-describedby="photoStartDateTo_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('seriesExternalId', { required: false })}
                               id="seriesExternalId"   name="seriesExternalId"  label="Series ID" aria-describedby="seriesExternalId_entry"
                               sx={{ width:180, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seriesName', { required: false })}
                               id="seriesName"   name="seriesName"  label="Series Name" aria-describedby="seriesName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonExternalId', { required: false })}
                               id="seasonExternalId"   name="seasonExternalId"  label="Season Id" aria-describedby="seasonExternalId_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberFrom', { required: false })}
                               id="seasonNumberFrom"   name="seasonNumberFrom"  label="# From" aria-describedby="seasonNumberFrom_entry"
                               sx={{ width: 140, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberTo', { required: false })}
                               id="seasonNumberTo"   name="seasonNumberTo"  label="# To" aria-describedby="seasonNumberTo_entry"
                               sx={{ width: 140, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonName', { required: false })}
                               id="seasonName"   name="seasonName"  label="Season Name" aria-describedby="seasonName_entry"
                               sx={{ width: 400 }} />
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('platformId', { required: false })}
                               id="platformId"   name="platformId"  label="Platform ID" aria-describedby="platformId_entry"
                               sx={{ width: 180 }} />
                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="platformName">Platform Name</InputLabel>
                        <Select
                            {...register('platformName', { required: false })}
                            labelId="demo-simple-select-filled-platformName"
                            id="platformName"
                            FreeSolo={true}
                            variant="filled"
                            label="platformName"
                            value={selectedPlatformName}
                            onChange={handlePlatformNameChange}
                            sx={{ width: 300}}
                        >
                            {platformNameDropdown.map((platformNameItem) =>
                                <MenuItem  FreeSolo={true} value={platformNameItem.singleField} key={platformNameItem.singleField}
                                >{platformNameItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="service">Service</InputLabel>
                        <Select
                            {...register('service', { required: false })}
                            labelId="demo-simple-select-filled-platformId"
                            id="service"
                            FreeSolo={true}
                            variant="filled"
                            label="service"
                            value={selectedPlatformService}
                            onChange={handlePlatformServiceChange}
                            sx={{ width: 200}}
                        >
                            {platformServiceDropdown.map((platformServiceItem) =>
                                <MenuItem  FreeSolo={true} value={platformServiceItem.singleField} key={platformServiceItem.singleField}
                                >{platformServiceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="usageMarket">Usage Market</InputLabel>
                        <Select
                            {...register('usageMarket', { required: false })}
                            labelId="demo-simple-select-filled-usageMarket"
                            id="usageMarket"
                            FreeSolo={true}
                            variant="filled"
                            label="usageMarket"
                            value={selectedUsageMarket}
                            onChange={handleUsageMarketChange}
                            sx={{ width: 200}}
                        >
                            {usageMarketDropdown.map((usageMarketItem) =>
                                <MenuItem  FreeSolo={true} value={usageMarketItem.singleField} key={usageMarketItem.singleField}
                                >{usageMarketItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="territory">Territory</InputLabel>
                        <Select
                            {...register('territory', { required: false })}
                            labelId="demo-simple-select-filled-territory"
                            id="territory"
                            FreeSolo={true}
                            variant="filled"
                            label="territory"
                            value={selectedTerritory}
                            onChange={handleTerritoryChange}
                            sx={{ width: 200}}
                        >

                            {territoryDropdown.map((territoryItem) =>
                                <MenuItem  FreeSolo={true} value={territoryItem.singleField} key={territoryItem.singleField}
                                >{territoryItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <FormDatePicker
                        name="viewDateFrom"
                        label="View Date From"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="viewDateTo"
                        label="View Date To"
                        control={control}
                        width={220}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('viewDateFrom', { required: false })}*/}
                    {/*           id="viewDateFrom"   name="viewDateFrom"  label="View Date From" aria-describedby="viewDateFrom_entry"*/}
                    {/*           sx={{ width: 180, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('viewDateTo', { required: false })}*/}
                    {/*           id="viewDateTo"   name="viewDateTo"  label="View Date To" aria-describedby="viewDateTo_entry"*/}
                    {/*           sx={{ width: 180, pr: 5 }} />*/}
                    <TextField variant="filled"
                               {...register('viewsFrom', { required: false })}
                               id="viewsFrom"   name="viewsFrom"  label="Views From" aria-describedby="viewsFrom_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('viewsTo', { required: false })}
                               id="viewsTo"   name="viewsTo"  label="Views To" aria-describedby="viewsTo_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('viewedMinutesFrom', { required: false })}
                               id="viewedMinutesFrom"   name="viewedMinutesFrom"  label="Viewed Minutes From" aria-describedby="viewedMinutesFrom_entry"
                               sx={{ width: 220, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('viewedMinutesTo', { required: false })}
                               id="viewedMinutesTo"   name="viewedMinutesTo"  label="Viewed Minutes To" aria-describedby="viewedMinutesTo_entry"
                               sx={{ width: 220, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('ratingFrom', { required: false })}
                               id="ratingFrom"   name="ratingFrom"  label="Rating From" aria-describedby="ratingFrom_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('ratingTo', { required: false })}
                               id="ratingTo"   name="ratingTo"  label="Rating To" aria-describedby="ratingTo_entry"
                               sx={{ width: 150, pr: 5 }} />
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <TextField variant="filled"
                               {...register('id', { required: false })}
                               id="id"   name="id"  label="ID" aria-describedby="id_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalId', { required: false })}
                               id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="source">Source</InputLabel>
                        <Select
                            {...register('source', { required: false })}
                            labelId="demo-simple-select-filled-source"
                            id="source"
                            FreeSolo={true}
                            variant="filled"
                            label="source"
                            value={selectedSource}
                            onChange={handleSourceChange}
                            sx={{ width: 200}}
                        >
                            {sourceDropdown.map((sourceItem) =>
                                <MenuItem  FreeSolo={true} value={sourceItem.singleField} key={sourceItem.singleField}
                                >{sourceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="status">Status</InputLabel>
                        <Select
                            {...register('status', { required: false })}
                            labelId="demo-simple-select-filled-status"
                            id="status"
                            FreeSolo={true}
                            variant="filled"
                            label="status"
                            value={selectedStatus}
                            onChange={handleStatusChange}
                            sx={{ width: 200}}
                        >
                            {statusDropdown.map((statusItem) =>
                                <MenuItem  FreeSolo={true} value={statusItem.singleField} key={statusItem.singleField}
                                >{statusItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>

            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

